import { startCase } from 'lodash-es';
import { chartEmptyValueConstants } from '@/utils/reports/chartEmptyValueConstants';
import { formatMonthString } from '@/utils/reports/chartTableFlatTransformer';

// Note: For jobs data, we're using 'opened_jobs' from headers; future versions may allow customization.

export const jobsTrendTransformer = ({ response }) => {
  const {
    table = [], // Default to an empty array if table data is missing
    headers = [], // Default to an empty array to avoid issues with missing headers
    lookups: { dt = [], g2 = [] } = {}, // Handle optional lookups with default values
  } = response || {};

  // Prepare the x-axis data (categories) from 'dt' lookup with formatted months
  const categories = dt.map(formatMonthString);

  // we are picking opened_jobs key from header, other options available are
  // target_breached_jobs, closed_jobs, closed_without_hires, open_time, time_to_close

  // Locate 'opened_jobs' in headers to easily retrieve the relevant data index
  const valueIndex = headers.indexOf('opened_jobs');

  // If 'opened_jobs' is not found in headers, return empty series
  if (valueIndex === -1) {
    return {
      categories, // Return x-axis data, even if empty
      series: [], // No y-axis data as 'opened_jobs' is missing
    };
  }

  const series = g2.map((source) => ({
    data: Array(categories.length).fill(0),
    name:
      source?.name ||
      (source ? startCase(source) : chartEmptyValueConstants?.appl_source),
    g2: source || null,
  }));

  // Prepare the series data for each group in 'g2' (e.g., different job categories or departments)
  table.forEach((weekRow) => {
    const weekIndex = weekRow[1]; // Week index (0, 1, 2, etc.)
    const sources = weekRow[0]; // Nested array of source data

    // Process each source entry for this week
    sources.forEach((sourceData) => {
      const g2Index = sourceData[3]; // g2 index (0, 1, 2, 3)
      const value = sourceData[valueIndex]; // opened_jobs value

      // If g2Index is valid and within our array bounds
      if (g2Index !== null && g2Index >= 0 && g2Index < series.length) {
        series[g2Index].data[weekIndex] = value;
      }
    });
  });

  // Return the transformed data with categories (x-axis) and series (y-axis)
  return {
    categories, // X-axis data (e.g., dates, time intervals)
    series, // Y-axis data for different groups (e.g., opened jobs per category)
  };
};
